// `204`: the payload names what was removed; the function then refetches the run, which carries the derived flags.
export type WorkflowRunSourceRemovedPayload = {
	runId: number;
	sourceId: number;
};

export type WorkflowRunSourceRemovedAction = {
	type: 'WORKFLOW_RUN_SOURCE_REMOVED';
	payload: WorkflowRunSourceRemovedPayload;
	facilityId: number;
	subjectId: number;
};

export default (
	payload: WorkflowRunSourceRemovedPayload,
	facilityId: number,
	subjectId: number,
): WorkflowRunSourceRemovedAction => ({
	type: 'WORKFLOW_RUN_SOURCE_REMOVED',
	payload,
	facilityId,
	subjectId,
});
